const {
  normalizeCountryCode
} = require('./countryCode');

/** Domain-neutral validation details; callers own HTTP errors and UI messages. */
class CountrySelectionError extends Error {
  constructor(reason) {
    let countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    super(reason);
    this.name = 'CountrySelectionError';
    this.reason = reason;
    this.countries = countries;
  }
}

/**
 * Normalizes and validates a non-empty country selection against a caller's Set
 * of allowed codes. ALL must be selected alone, but can coexist with explicit
 * countries in other rules so callers can implement a country-specific fallback.
 * Duplicate assignments (including aliases) are rejected within the selection
 * and against assignedCountries. Neither input collection is mutated.
 * The allowed and already assigned country codes must be normalized.
 * Date overlap, brand scope, persistence and fallback resolution belong to callers.
 */
const normalizeCountrySelection = function (values, allowedCountryCodes) {
  let assignedCountries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!Array.isArray(values) || !values.length) {
    throw new CountrySelectionError('COUNTRIES_REQUIRED');
  }
  const countries = values.map(normalizeCountryCode);
  if (countries.some(code => code !== 'ALL' && !allowedCountryCodes.has(code))) {
    throw new CountrySelectionError('INVALID_COUNTRY');
  }
  if (countries.includes('ALL') && countries.length !== 1) {
    throw new CountrySelectionError('ALL_WITH_COUNTRIES');
  }
  const assigned = new Set(assignedCountries);
  countries.forEach(country => {
    if (assigned.has(country)) {
      throw new CountrySelectionError('DUPLICATE_COUNTRY', [country]);
    }
    assigned.add(country);
  });
  return countries;
};
module.exports = {
  CountrySelectionError,
  normalizeCountrySelection
};